(() => {
  if (window.barewayPdpStandardLoaded) return;
  window.barewayPdpStandardLoaded = true;
  const rootUrl = window.Shopify?.routes?.root || '/';
  class BarewayPairOffer extends HTMLElement {
    connectedCallback() {
      this.refresh = this.refresh.bind(this);
      this.refresh();
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, this.refresh);
      this.addEventListener('bareway:cart-updated', this.refresh);
    }
    disconnectedCallback() { this.unsubscribe?.(); }
    async refresh() {
      try {
        const response = await fetch(`${rootUrl}?sections=cart-drawer`);
        if (!response.ok) throw new Error('Cart status unavailable');
        const sections = await response.json();
        if (typeof sections['cart-drawer'] !== 'string') throw new Error('Cart section unavailable');
        const html = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        const message = html.querySelector('.bw-cart-pair-status strong');
        this.querySelector('[data-pair-status]').textContent = message?.textContent || '';
      } catch { this.querySelector('[data-pair-status]').textContent = ''; }
    }
  }
  if (!customElements.get('bareway-pair-offer')) customElements.define('bareway-pair-offer', BarewayPairOffer);
  // Shrine's drawer inherits the full-cart refresh. Keep drawer updates in its own section.
  customElements.whenDefined('cart-drawer-items').then(() => {
    const DrawerItems = customElements.get('cart-drawer-items');
    DrawerItems.prototype.onCartUpdate = async function () {
      try {
        const sections = await fetch(`${rootUrl}?sections=cart-drawer`).then(response => response.json());
        const html = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        const next = html.querySelector('cart-drawer-items');
        if (next && this.isConnected) this.innerHTML = next.innerHTML;
      } catch {}
    };
  });
  function updateDelivery() {
    document.querySelectorAll('[data-bw-delivery]').forEach(panel => {
      const start = new Date();start.setHours(12, 0, 0, 0);const end = new Date(start);
      start.setDate(start.getDate() + 7);end.setDate(end.getDate() + 10);
      try {
        const format = new Intl.DateTimeFormat(panel.dataset.locale || 'en', { day: 'numeric', month: 'long', year: 'numeric' });
        panel.querySelector('[data-bw-date]').textContent = format.formatRange ? format.formatRange(start, end) : `${format.format(start)} – ${format.format(end)}`;
      } catch {}
    });
  }
  function prepareDialog(dialog) {
    if (dialog.dataset.ready) return;
    dialog.dataset.ready = 'true';
    const variants = JSON.parse(dialog.querySelector('[data-bw-variants]').textContent);
    const form = dialog.querySelector('[data-bw-pair-form]');
    const choices = [...dialog.querySelectorAll('[data-bw-option]')];
    const button = form.querySelector('button[type="submit"]');
    const error = form.querySelector('[data-bw-error]');
    const update = () => {
      const selected = choices.map(choice => choice.value);
      const variant = variants.find(v => v.options.every((value, index) => value === selected[index]));
      form.querySelector('[name="id"]').value = variant?.id || '';
      button.disabled = !variant?.available;
      button.textContent = variant?.available ? dialog.dataset.addLabel : dialog.dataset.unavailable;
      if (variant) {
        dialog.querySelector('[data-bw-pair-price]').textContent = new Intl.NumberFormat(dialog.dataset.locale || 'en', { style: 'currency', currency: dialog.dataset.currency || 'USD', currencyDisplay: 'narrowSymbol' }).format(variant.price / 100);
        const image = dialog.querySelector('.bw-pair-dialog__image');
        if (variant.image) { image.src = variant.image; image.removeAttribute('srcset'); }
      }
      choices.forEach((choice, index) => {
        if (!/size|tamanho/i.test(choice.closest('label').firstChild.textContent)) return;
        [...choice.options].forEach(option => { option.disabled = !variants.some(v => v.available && v.options[index] === option.value && v.options.every((value, i) => i === index || value === selected[i])); });
      });
    };
    choices.forEach(choice => choice.addEventListener('change', () => { error.hidden = true; update(); }));
    form.addEventListener('submit', async event => {
      event.preventDefault();if (button.disabled) return;
      const variantId = Number(form.querySelector('[name="id"]').value);
      button.disabled = true;button.textContent = dialog.dataset.adding;error.hidden = true;
      try {
        const drawer = document.querySelector('cart-drawer');
        const payload = { id: variantId, quantity: 1, sections_url: location.pathname };
        if (drawer) payload.sections = drawer.getSectionsToRender().map(section => section.id);
        const response = await fetch(dialog.dataset.addUrl || `${rootUrl}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(payload) });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || dialog.dataset.error);
        dialog.close();
        if (drawer) { drawer.classList.remove('is-empty');drawer.setActiveElement(dialog.bwOpener);drawer.renderContents(result); }
        else location.href = `${rootUrl}cart`;
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bareway-second-pair', productVariantId: variantId, cartData: result });
        else document.querySelectorAll('bareway-pair-offer').forEach(offer => offer.dispatchEvent(new Event('bareway:cart-updated')));
      } catch (failure) { error.textContent = failure.message || dialog.dataset.error;error.hidden = false; }
      finally { update(); }
    });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    update();
  }
  document.addEventListener('click', event => {
    const open = event.target.closest('[data-bw-open]');
    if (open) { const dialog = document.getElementById(open.dataset.bwOpen);if (dialog) { prepareDialog(dialog);dialog.bwOpener = open;dialog.showModal(); } }
    const close = event.target.closest('[data-bw-close]');if (close) close.closest('dialog').close();
    const faq = event.target.closest('[data-bw-faq-link]');if (faq) { const target = document.getElementById(faq.hash.slice(1));if (target) target.open = true; }
    const guide = event.target.closest('[data-bw-guide]');if (guide) document.getElementById(guide.dataset.bwGuide)?.showModal();
  });
  updateDelivery();document.addEventListener('shopify:section:load', updateDelivery);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) updateDelivery(); });
})();

